import { Menu as MenuPrimitive } from '@base-ui/react/menu';

const createDropdownMenuHandle = MenuPrimitive.createHandle;

export default createDropdownMenuHandle;
